import React from 'react';

export default function Intro(){
    return(
        <div className='info-container'>
            <p className='hello'>Welcome</p>
            <p className='myintro'>I'm Shyam swaran, a computer science engineering student conquering the world of bits and bytes.</p>
        </div>
    )
}